module.exports = __webpack_public_path__ + "img/projects.439c53c8.svg";